import { Flex, Icon } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { MapComponent } from "../../survey/stores/MapStore";
import { useStores } from "../../shared/stores/RootStore";
import { ChevronLeftIcon } from "../../shared/views/icons";

const ToggleVisibilityButtonBase = ({
  component,
  arrowAngleWhenOpen,
}: {
  component: MapComponent;
  arrowAngleWhenOpen: number;
}) => {
  const { mapStore } = useStores();

  const open = mapStore.componentVisibility[component];

  const arrowAngle = open ? arrowAngleWhenOpen + 180 : arrowAngleWhenOpen;

  return (
    <Flex
    bgColor={"gray.100"}
      alignItems={"center"}
      justifyContent={"center"}
      cursor={"pointer"}
      _hover={{ bgColor: "primary.50" }}
      onClick={() => {
        mapStore.setComponentVisibility((prev) => ({
          ...prev,
          [component]: !prev[component],
        }));
      }}
    >
      <Icon
        rotate={`${arrowAngle}deg`}
        transition={"0.4s"}
        as={ChevronLeftIcon}
      />
    </Flex>
  );
};

export const ToggleVisibilityButton = observer(ToggleVisibilityButtonBase);
